import type { StepColumnType } from "@stepfinance/react";

export type ExtendedStepColumnsType<RecordType = unknown> = (
  | StepColumnType<RecordType>
  | ((args: GetColumnsArgs["args"]) => StepColumnType<RecordType>)
)[];

export type ColumnMapType<RecordType = unknown> = {
  default: ExtendedStepColumnsType<RecordType>;
  [key: string]: ExtendedStepColumnsType<RecordType>;
};

export interface GetColumnsArgs<RecordType = unknown> {
  selector?: string;
  map: ColumnMapType<RecordType>;
  args: { [key: string]: any };
}

const processColumnsContexts = <RecordType = unknown>(columns, args): StepColumnType<RecordType>[] =>
  columns.map((column) => {
    if (column instanceof Function) {
      return column(args);
    } else {
      return column;
    }
  });

export const getColumns = <RecordType = unknown>({ selector, map, args }: GetColumnsArgs<RecordType>) => {
  let columnList = map.default;
  if (selector && map[selector]) {
    columnList = map[selector];
  }
  return processColumnsContexts<RecordType>(columnList, args);
};
